/**
 * @generated SignedSource<<b894f6695424e9031c8dd101801eb6da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MobileHeaderFragment_club$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  readonly " $fragmentType": "MobileHeaderFragment_club";
};
export type MobileHeaderFragment_club$key = {
  readonly " $data"?: MobileHeaderFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"MobileHeaderFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileHeaderFragment_club",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FacilityLogoFragment_club"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "c3163b01fb53ebb4044823c1a90184b3";

export default node;
